import {
  CREATE_LICENSE_USER,
  CREATE_LICENSE_USER_SUCCESS,
  CREATE_LICENSE_USER_ERROR,
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTIONS_SUCCESS,
  GET_SUBSCRIPTIONS_ERROR,
  GET_SUBSCRIPTION_BILLINGS,
  GET_SUBSCRIPTION_BILLINGS_SUCCESS,
  GET_SUBSCRIPTION_BILLINGS_ERROR,
  CHECK_SUBSCRIPTION_STATUS,
  CHECK_SUBSCRIPTION_STATUS_SUCCESS,
  CHECK_SUBSCRIPTION_STATUS_ERROR,
  DELETE_SUBSCRIPTION,
  DELETE_SUBSCRIPTION_SUCCESS,
  DELETE_SUBSCRIPTION_ERROR,
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_ERROR,
  MARK_SUBSCRIPTION_PAID,
  MARK_SUBSCRIPTION_PAID_SUCCESS,
  MARK_SUBSCRIPTION_PAID_ERROR,
  FREEZE_UNFREEZE_SUBSCRIPTION,
  FREEZE_UNFREEZE_SUBSCRIPTION_SUCCESS,
  FREEZE_UNFREEZE_SUBSCRIPTION_ERROR,
} from "./actionTypes";

import * as licenseApi from "../../apis/license";

// Create License User
export const createLicenseUser = (customerId) => ({
  type: CREATE_LICENSE_USER,
  payload: { customerId },
});

export const createLicenseUserSuccess = (payload) => ({
  type: CREATE_LICENSE_USER_SUCCESS,
  payload,
});

export const createLicenseUserError = (error) => ({
  type: CREATE_LICENSE_USER_ERROR,
  payload: error,
});

// Create Subscription
export const createSubscription = (customerId, payload) => ({
  type: CREATE_SUBSCRIPTION,
  payload: { customerId, payload },
});

export const createSubscriptionSuccess = (payload) => ({
  type: CREATE_SUBSCRIPTION_SUCCESS,
  payload,
});

export const createSubscriptionError = (error) => ({
  type: CREATE_SUBSCRIPTION_ERROR,
  payload: error,
});

// Get Subscriptions
export const getSubscriptions = (params = {}) => ({
  type: GET_SUBSCRIPTIONS,
  payload: params,
});

export const getSubscriptionsSuccess = (payload) => ({
  type: GET_SUBSCRIPTIONS_SUCCESS,
  payload,
});

export const getSubscriptionsError = (error) => ({
  type: GET_SUBSCRIPTIONS_ERROR,
  payload: error,
});

// Get Subscription Billings
export const getSubscriptionBillings = (
  subscriptionId,
  page = 1,
  limit = 10
) => ({
  type: GET_SUBSCRIPTION_BILLINGS,
  payload: { subscriptionId, page, limit },
});

export const getSubscriptionBillingsSuccess = (payload) => ({
  type: GET_SUBSCRIPTION_BILLINGS_SUCCESS,
  payload,
});

export const getSubscriptionBillingsError = (error) => ({
  type: GET_SUBSCRIPTION_BILLINGS_ERROR,
  payload: error,
});

// Check Subscription Status
export const checkSubscriptionStatus = (customerId) => ({
  type: CHECK_SUBSCRIPTION_STATUS,
  payload: { customerId },
});

export const checkSubscriptionStatusSuccess = (payload) => ({
  type: CHECK_SUBSCRIPTION_STATUS_SUCCESS,
  payload,
});

export const checkSubscriptionStatusError = (error) => ({
  type: CHECK_SUBSCRIPTION_STATUS_ERROR,
  payload: error,
});

// Delete Subscription
export const deleteSubscription = (customerId, subscriptionId) => ({
  type: DELETE_SUBSCRIPTION,
  payload: { customerId, subscriptionId },
});

export const deleteSubscriptionSuccess = (payload) => ({
  type: DELETE_SUBSCRIPTION_SUCCESS,
  payload,
});

export const deleteSubscriptionError = (error) => ({
  type: DELETE_SUBSCRIPTION_ERROR,
  payload: error,
});

// Get Products
export const getProducts = (page = 1, limit = 10) => ({
  type: GET_PRODUCTS,
  payload: { page, limit },
});

export const getProductsSuccess = (payload) => ({
  type: GET_PRODUCTS_SUCCESS,
  payload,
});

export const getProductsError = (error) => ({
  type: GET_PRODUCTS_ERROR,
  payload: error,
});

// Mark Subscription as Paid
export const markSubscriptionAsPaid = (
  customerId,
  subscriptionId,
  payload
) => ({
  type: MARK_SUBSCRIPTION_PAID,
  payload: { customerId, subscriptionId, payload },
});

export const markSubscriptionAsPaidSuccess = (payload) => ({
  type: MARK_SUBSCRIPTION_PAID_SUCCESS,
  payload,
});

export const markSubscriptionAsPaidError = (error) => ({
  type: MARK_SUBSCRIPTION_PAID_ERROR,
  payload: error,
});

// Freeze/Unfreeze Subscription Success/Error Actions
export const freezeUnfreezeSubscriptionSuccess = (payload) => ({
  type: FREEZE_UNFREEZE_SUBSCRIPTION_SUCCESS,
  payload,
});

export const freezeUnfreezeSubscriptionError = (error) => ({
  type: FREEZE_UNFREEZE_SUBSCRIPTION_ERROR,
  payload: error,
});

export const freezeUnfreezeSubscription = (
  customerId,
  subscriptionId,
  data,
  page = 1,
  limit = 10
) => ({
  type: FREEZE_UNFREEZE_SUBSCRIPTION,
  payload: { customerId, subscriptionId, data, page, limit },
});
